import React from "react";
import "./AppBar.css";

const ProcedureMoveAppBar = ({
  title = "",
  buttons = [],
  setSelectedView,
  selectedView,
  showBackButton = true,
  showCancelButton = true,
  subheadingBelowTitle = "",
  titleFontSize = "20px",
}) => {
  const showSubheading =
    subheadingBelowTitle && subheadingBelowTitle.trim() !== "to";
  return (
    <header className="appbar">
      {showCancelButton && (
        <button
          className="appbar-button-secondary"
          onClick={() => window.history.back()}
          style={{
            backgroundColor: "#f1f3f4",
            color: "#47515c",
            border: "none",
            padding: "8px 12px",
            cursor: "pointer",
            borderRadius: "4px",
            marginLeft: "15px",
            marginRight: "15px",
          }}
        >
          Cancel
        </button>
      )}
      {showBackButton && (
        <button className="back-button" onClick={() => window.history.back()}>
          <svg
            viewBox="6 4 16 16"
            width="48"
            height="48"
            style={{ color: "#0D6EFD" }}
          >
            <path
              d="M10 12h10M10 12l4-4M10 12l4 4"
              stroke="currentColor"
              strokeWidth="1.5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}

      {/* Radio Buttons for View Toggle */}
      <div
        className="view-toggle"
        style={{
          width: "300px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginLeft: "20px",
        }}
      >
        <label
          style={{
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            gap: "2px",
            cursor: "pointer",
          }}
        >
          <input
            type="radio"
            name="view"
            value="original"
            checked={selectedView === "original"}
            onChange={() => setSelectedView("original")}
            style={{ cursor: "pointer" }}
          />
          <span
            style={{ fontSize: "10px", whiteSpace: "nowrap", marginTop: "3px" }}
          >
            View Original
          </span>
        </label>
        <label
          style={{
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            gap: "2px",
            cursor: "pointer",
          }}
        >
          <input
            type="radio"
            name="view"
            value="new"
            checked={selectedView === "new"}
            onChange={() => setSelectedView("new")}
            style={{ cursor: "pointer" }}
          />
          <span
            style={{ fontSize: "10px", whiteSpace: "nowrap", marginTop: "3px" }}
          >
            View New
          </span>
        </label>
      </div>
      <h2
        style={{
          fontSize: titleFontSize,
          color: "#0D6EFD",
          marginLeft: "20px",
          marginTop: 0,
          marginBottom: 0,
          flex: "1 1 auto",
          minWidth: 0,
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          fontWeight: 600,
        }}
      >
        {title}
      </h2>

      {showSubheading && (
        <p
          style={{
            fontSize: "13px",
            color: "#000",
            marginTop: "4px",
            maxWidth: "700px",
            marginLeft: "auto",
            marginRight: "auto",
            wordBreak: "break-word",
          }}
        >
          {subheadingBelowTitle}
        </p>
      )}
      <div className="appbar-buttons">
        {buttons.map((button, index) => (
          <button
            key={index}
            disabled={!!button.disabled}
            className={`${
              button.label === "Preview" ||
              button.label === "Request Change" ||
              button.label.toLowerCase().includes("move") ||
              button.label.toLowerCase().includes("review against")
                ? "appbar-button-secondary"
                : "appbar-button"
            }`}
            onClick={button.onClick}
            style={
              button.disabled
                ? { opacity: 0.55, cursor: "not-allowed", pointerEvents: "none" }
                : undefined
            }
          >
            {button.label}
          </button>
        ))}
      </div>
    </header>
  );
};

export default ProcedureMoveAppBar;
